import { deleteRequest, getRequest, postRequest, putRequest, patchRequest } from "api/axiosClient";

const { REACT_APP_CARGOBASE_BASE_URL } = import.meta.env;
const baseURL = `${REACT_APP_CARGOBASE_BASE_URL}/invoice`;

const getExchangeRates = (id, config) => getRequest(`${baseURL}/${id}/currency-conversion`, config);
const getInvoiceAttachmentBuckets = (config = {}) =>
  getRequest(`${REACT_APP_CARGOBASE_BASE_URL}/invoice-attachment-bucket`, config);
const getInvoiceAttachments = (id) => getRequest(`${baseURL}/${id}/attachments`);
const getInvoiceAuditLog = (id) => getRequest(`${baseURL}/${id}/audit`);
const getInvoicePDF = (id) => getRequest(`${baseURL}/${id}/print`, { responseType: "blob" });
const getInvoices = (config = {}) => getRequest(`${REACT_APP_CARGOBASE_BASE_URL}/invoices`, config);
const getShipmentInvoices = (id) => getRequest(`${REACT_APP_CARGOBASE_BASE_URL}/shipment-invoices/${id}`);
const getInvoiceProviders = () => getRequest(`${baseURL}/available-providers`);
const postInvoiceAuditLogMessage = (id, payload) => postRequest(`${baseURL}/${id}/audit`, payload);
const updateExchangeRate = (id, payload) => putRequest(`${baseURL}/${id}/currency-conversion`, payload);
const updateInvoice = (id, payload) => putRequest(`${baseURL}/${id}/update`, payload);
const updateInvoicePaymentStatus = (id, payload) => putRequest(`${baseURL}/${id}/payment-status/update`, payload);
const getInvoiceComments = (id) => getRequest(`${REACT_APP_CARGOBASE_BASE_URL}/billing/${id}/comments`);
const getInvoiceStatusCount = () => getRequest(`${baseURL}/count`);
const getInvoiceConfig = (shipmentId, config) => getRequest(`${baseURL}/${shipmentId}/config`, config);
const getInvoiceDraft = (invoiceId) => getRequest(`${baseURL}/draft/${invoiceId}/get`);
const createInvoiceDraft = (id) => postRequest(`${baseURL}/draft/${id}`);
const deleteInvoiceDraft = (id) => deleteRequest(`${baseURL}/draft/${id}/delete`);
const revertExchangeRate = (id, currency) => deleteRequest(`${baseURL}/${id}/currency-conversion`, currency);
const saveInvoiceDraft = (id, payload, config = {}) => putRequest(`${baseURL}/draft/${id}/update`, payload, config);
const cancelInvoice = (id) => putRequest(`${baseURL}/${id}/cancel`);
const submitInvoice = (id) => postRequest(`${baseURL}/${id}/submit`);
const revertRemovedInvoice = (id) => putRequest(`${baseURL}/${id}/revert`);
const createIntermediateInvoice = (id) => postRequest(`${baseURL}/draft/${id}/intermediate`, {});
const updateInvoiceAttachmentBucket = (id, payload) =>
  putRequest(`${REACT_APP_CARGOBASE_BASE_URL}/invoice-attachment-bucket/${id}`, payload);
const createInvoiceAttachmentBucket = (payload) =>
  postRequest(`${REACT_APP_CARGOBASE_BASE_URL}/invoice-attachment-bucket`, payload);

const createInvoiceBucketAttachment = (invoiceId, payload, config = {}) =>
  postRequest(`${baseURL}/${invoiceId}/bucket-attachments`, payload, config);

const patchInvoiceBucketAttachment = (invoiceId, fileReference, payload) =>
  patchRequest(`${baseURL}/${invoiceId}/bucket-attachments/${fileReference}`, payload);

const deleteInvoiceBucketAttachment = (invoiceId, fileReference, bucketId) =>
  deleteRequest(`${baseURL}/${invoiceId}/bucket-attachments/${fileReference}`, {
    params: { bucket_id: bucketId },
  });

export {
  getExchangeRates,
  getInvoiceAttachmentBuckets,
  getInvoiceAttachments,
  getInvoiceAuditLog,
  getInvoicePDF,
  getInvoices,
  getInvoiceProviders,
  postInvoiceAuditLogMessage,
  updateExchangeRate,
  updateInvoice,
  updateInvoicePaymentStatus,
  getShipmentInvoices,
  getInvoiceComments,
  getInvoiceStatusCount,
  getInvoiceConfig,
  createInvoiceDraft,
  deleteInvoiceDraft,
  getInvoiceDraft,
  saveInvoiceDraft,
  cancelInvoice,
  submitInvoice,
  revertRemovedInvoice,
  revertExchangeRate,
  createIntermediateInvoice,
  updateInvoiceAttachmentBucket,
  createInvoiceAttachmentBucket,
  createInvoiceBucketAttachment,
  patchInvoiceBucketAttachment,
  deleteInvoiceBucketAttachment,
};
